import { useEffect, useState } from 'react';
import '../styles/PopupMessage.css';

interface PopupMessageProps {
    message: string;
    type: string; // e.g., 'success', 'error', 'info'
    onClose: () => void;
    autoClose?: boolean;
    duration?: number;
}

function PopupMessage({ message, type, onClose, autoClose = true, duration = 5000 }: PopupMessageProps) {
    const [isVisible, setIsVisible] = useState(true);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (autoClose) {
            const timer = setTimeout(() => {
                handleClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [autoClose, duration]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsVisible(false);
            onClose();
        }, 300); // animation duration
    };

    if (!isVisible) return null;

    return (
        <div className={`popup-message ${type} ${isClosing ? 'closing' : ''} ${autoClose ? 'auto-close' : ''}`}>
            <div className="popup-content">
                <p>{message}</p>
                <button onClick={handleClose} className="close-button">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default PopupMessage;